<template lang="pug">

div

    //- Navigation
    navigation(@toggle="$emit('toggle')")

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column: h2.ui.header
    //-             i.list.ol.icon
    //-             .content Kampagnen
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Kein Einträge vorhanden
    .ui.bottom.no-users.icon.message(v-if='campaigns.length === 0')
        i.meh.icon
        .content: .header Keine Kampagnen gefunden

    template(v-else)

        //- Content
        campaigns-table.ui.segment(
            v-bind:campaign-models='campaigns'
            v-bind:company-models='companies'
        )

        //- Pagination
        .ui.bottom.secondary
            .ui.two.column.grid
                .middle.aligned.column
                    .ui.form
                        .inline.fields(style='margin: 0')
                            label Zeilen pro Seite:
                            .field
                                select.ui.selection.dropdown(ref='pageSizeDropdown')
                                    option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
                .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                    .ui.pagination.menu
                        a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                            i.left.chevron.icon
                        a.item(
                            v-for='page in totalPages'
                            v-bind:key='page'
                            v-bind:class='{ active: page === currentPage }'
                            v-on:click='currentPage = page'
                        ) {{ page }}
                        a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                            i.right.chevron.icon

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/products/Navigation'
    import CampaignsTable from '@/components/campaigns/Table'

    async function load_page({ page = 0, size = 20 } = {}) {
        const campaigns = await store.dispatch('campaigns/loadPage', { page, size })
        // Unternehmen der aktuellen Seite laden (gecacht nach erstem Aufruf)
        await Promise.all(
            campaigns.map(c => store.dispatch('companies/loadOne', { id: c.company }))
        )
        return campaigns
    }

    //noinspection JSUnusedLocalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            load_page().then(campaigns => next(vm => { vm.pageCampaigns = campaigns }))
        },

        components: { CampaignsTable, Navigation },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage: 1,
                itemsPerPage: 25,
                pageCampaigns: [],
                pageSizeOptions: [25, 50, 100, 250],
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                this.pageCampaigns = await load_page({
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                })
            }
        },

        computed: {

            campaigns() {
                return this.pageCampaigns
            },

            companies() {
                return this.$store.getters['companies/all']
            },

            totalPages() {
                const total = this.$store.getters['campaigns/counts'].total || 0
                return Math.ceil(total / this.itemsPerPage)
            },

        }

    }

</script>
